import BrandPassportPopup from 'components/BrandPassportPopup';
import PerformancePopup from 'components/PerformancePopup';

const normalizePath = (path) => {
  if (!path) return '/';

  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
  const withoutQuery = withLeadingSlash.split(/[?#]/)[0];
  const trimmed = withoutQuery.replace(/\/+$/g, '');

  return trimmed || '/';
};

const performancePaths = [
  '/projects-performance',
  '/global-lead-generation',
  '/performance',
  '/seo',
  '/aso',
  '/context',
  '/target',
  '/nuself',
  '/melwin',
  '/okko',
  '/belleyou',
  '/quadcode',
  '/offschool',
  '/livedune',
  '/boft',
  '/interleasing',
  '/knauftherm',
  '/fitfashion',
  '/condenast-2',
  '/uninova-seo-redesign',
  '/softline-store',
  '/ati',
  '/gazpromneft-seo',
  '/msbaby',
  '/hqts',
  '/docklands',
  '/ati',
  '/tonika',
  '/geek-picnic',
  '/aist',
  '/condenast',
  '/tveda',
  '/mcrm',
  '/iport',
  '/svezhee',
  '/ff',
  '/probalance',
  '/dikom',
  '/saf'
];

export const popupRegistry = [
  {
    id: 'performance-services-popup',
    Component: PerformancePopup,
    match: (path) => {
      const normalized = normalizePath(path);
      return performancePaths.includes(normalized);
    }
  }
];

export const defaultPopup = BrandPassportPopup;

export const resolvePopup = (path) => {
  const normalized = normalizePath(path);
  const entry = popupRegistry.find((popup) => popup.match(normalized));

  if (!entry) {
    return defaultPopup;
  }

  return entry.Component || null;
};

export { normalizePath };
